import { Box, Stack } from '@mui/material';

import { ColorsRaw } from '@/ui/theme/colors-raw';

export function PercentageCursorBar({ percentage }: { percentage: number }) {
  return (
    <Stack position={'relative'} height={32}>
      <Box
        sx={{
          bgcolor: ColorsRaw.anthracite.Anthracite_5,
          width: '100%',
          height: 6,
          borderRadius: 8,
          position: 'absolute',
          top: '50%',
          transform: 'translateY(-50%)',
          zIndex: 20,
        }}
      />
      <Box
        sx={{
          bgcolor: ColorsRaw.secondary.Logo_Blue,
          height: 6,
          borderRadius: 8,
          width: `${percentage}%`,
          position: 'absolute',
          top: '50%',
          transform: 'translateY(-50%)',
          zIndex: 30,
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          bgcolor: ColorsRaw.secondary.Logo_Blue,
          color: ColorsRaw.basic.Cream,
          borderRadius: '5px',
          height: 32,
          px: 0.5,
          fontSize: 24,
          fontWeight: 800,
          zIndex: 40,
          display: 'flex',
          alignItems: 'center',
          ...{ ...getGapFromLeft(percentage) },
        }}
      >
        {percentage}%
      </Box>
    </Stack>
  );
}

const getGapFromLeft = (percentage: number) => {
  if (percentage <= 5)
    return {
      left: 0,
      transform: 'translateY(-50%)',
    };
  else if (percentage >= 95)
    return {
      right: 0,
      transform: 'translateY(-50%)',
    };
  return {
    left: `${percentage}%`,
    transform: 'translateX(-50%) translateY(-50%)',
  };
};
